.shell {
  display: grid;
  grid-template-rows: auto minmax(0, 1fr) auto;
  grid-template-columns: minmax(0, 1fr);
  height: 100dvh;
  max-width: 600px;
  margin: 0 auto;
  background: var(--chassis);
}

/* Header on --chassis: style picker left, project chip right (DESIGN_SYSTEM §4). Both show their full names: when the
   chip does not fit beside the picker it wraps to its own full-width row, never an ellipsis (audit A1). */
.header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--s3);
  padding: calc(env(safe-area-inset-top) + var(--s3)) var(--gutter) var(--s3);
}

.picker {
  composes: pad pressable from '../ui/surface.module.css';

  display: inline-flex;
  align-items: center;
  gap: var(--s2);
  min-width: 0;
  max-width: 100%;
  min-height: var(--target);
  padding: 0 var(--s3) 0 var(--s4);
  border-radius: var(--r-control);
  font-size: 1.1875rem;
  line-height: 1.2;
  font-weight: 650;
  font-stretch: 100%;
}

.pickerName {
  min-width: 0;
  overflow-wrap: anywhere;
}

.chip {
  composes: pressable from '../ui/surface.module.css';

  display: inline-flex;
  align-items: center;
  flex: 1 1 auto;
  justify-content: flex-start;
  max-width: 100%;
  min-height: var(--target);
  padding: var(--s2) var(--s3);
  border-radius: var(--r-control);
  background: var(--panel2);
  color: var(--ink);
  font-size: 1rem;
  line-height: 1.3;
  font-weight: 650;
  font-stretch: 90%;
}

.chipName {
  min-width: 0;
  overflow-wrap: anywhere;
}

/* Content on a --panel surface with 12 px top corners. min-width: 0 keeps a
   wide grid item (a scrolling table or chart deep inside) from stretching
   this grid track past the viewport - overflow-y alone only guards the
   block axis. */
.main {
  min-width: 0;
  overflow: hidden auto;
  overscroll-behavior: contain;
  background: var(--panel);
  border-radius: var(--r-sheet) var(--r-sheet) 0 0;
  outline: none;
}

.nav {
  background: var(--panel);
  border-top: 1px solid var(--line);
  padding-bottom: env(safe-area-inset-bottom);
}

.navList {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  height: var(--nav-h);
}

.navLink {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  height: 100%;
  overflow: hidden;
  color: var(--ink2);
  font-size: 0.875rem;
  line-height: 1.2;
  font-weight: 500;
  font-stretch: 90%;
}

.navLink:active {
  background: var(--panel2);
}

.navLink[aria-current='page'] {
  color: var(--slate);
  font-weight: 700;
}

.search {
  width: 100%;
  min-height: var(--target);
  padding: 0 var(--s4);
  margin-bottom: var(--s2);
  background: var(--panel);
  border: 1px solid var(--line);
  border-radius: var(--r-control);
  color: var(--ink);
  font-size: 1rem;
}

.search::placeholder {
  color: var(--ink2);
}

.groupLabel {
  margin: var(--s4) 0 var(--s1);
  color: var(--ink2);
}

.styleRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 52px;
  padding: 0;
  border: 0;
  border-top: 1px solid var(--line);
  background: transparent;
  color: var(--ink);
  font-size: 1rem;
  line-height: 1.3;
  font-weight: 500;
  text-align: left;
}

.styleRow:active {
  background: var(--panel2);
}

.styleRow[aria-checked='true'] {
  color: var(--slate);
  font-weight: 700;
}

.skip {
  position: absolute;
  left: var(--s2);
  top: var(--s2);
  z-index: 40;
  display: inline-flex;
  align-items: center;
  min-height: var(--target);
  padding: 0 var(--s3);
  background: var(--ink);
  color: var(--panel);
  border-radius: var(--r-control);
  transform: translateY(-200%);
}

.skip:focus {
  transform: none;
}
